import ProcessNavigation from '@/components/process-navigation/index.vue';
import { mapGetters } from 'vuex';
// import { errorMessage } from '@/utils/message.js';

import PublishPurchaseService from '../publish-purchase-service';
const debounce = require('lodash.debounce');

export default {
  components: {
    ProcessNavigation
  },
  data () {
    return {
      // processList: ['业务流程及准备材料', '编辑项目信息', '编辑意向供应人（投标人）资格要求', '上传附件信息', '确定承诺信息', '编辑采购文件', '提交申请'],
      step: 5,
      id: '',
      oldId: '',
      isAgree: '',
      submitStatus: 'init',
      projectTypeOfPur: null,
      pruchaseInfo: {},
      citytitle: ''
    };
  },
  computed: {
    ...mapGetters({
      processList: 'purchaseProcessList'
    })
  },
  created () {
    window.scrollTo(0, 0);
    this.id = this.$route.query.id;
    this.oldId = this.$route.query.oldId;
    this.projectTypeOfPur = this.$route.query.projectTypeOfPur;
    this.getPurchaseInfo();
  },
  methods: {
    getPurchaseInfo () {
      let params = {
        purchaseId: this.id || this.oldId,
        echoCode: 'PURCHASE'
      };
      this.$store.dispatch('getPurchaseInfo', params).then(res => {
        this.pruchaseInfo = res.data;
      });
    },
    previousStep () {
      this.$router.back();
    },
    next: debounce(function () {
      if (this.submitStatus === 'ongoing') { return; }
      if (!this.isAgree) return;
      this.submitStatus = 'ongoing';

      // 一般招标 依法招标
      if ([4, 5].includes(this.pruchaseInfo.purchaseType)) {
        PublishPurchaseService.submitProjectProcess(this.id || this.oldId).then(res => {
          if (res && res.code === '0') {
            this.submitStatus = 'success';
            this.$router.push('/publish-purchase/success');
          }
        }).catch(error => {
          this.submitStatus = 'init';
          if (error && error.data && error.data.reason) {
            this.$errorMessage(error.data.reason);
          } else {
            this.$errorMessage('保存项目信息失败');
          }
        });
      } else {
        if (this.oldId) {
          this.$router.push(`/publish-purchase/editPurchase-file?id=${this.id}&oldId=${this.oldId}&projectTypeOfPur=${this.projectTypeOfPur}`);
        } else {
          this.$router.push(`/publish-purchase/editPurchase-file?id=${this.id}&projectTypeOfPur=${this.projectTypeOfPur}`);
        }
      }
    }, 2000, {
      'leading': true,
      'trailing': false
    })
  }
};
